<script>
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    value: String,
    type: String,
    targetDate: String,
    max: [String, undefined],
    min: [String, undefined],
    hideDetails: Boolean
  },
  data() {
    return {
      isOpenMenu: false
    };
  },
  computed: {
    selectedDate: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$forceUpdate();
      }
    },
    validateDateRange() {
      // fromよりもtoが小さい場合、バリデーションエラーを設定する
      if (!this.isEmpty(this.targetDate) && !this.isEmpty(this.selectedDate)) {
        let from;
        let to;
        if (this.type === "from") {
          from = new Date(this.selectedDate);
          to = new Date(this.targetDate);
        } else {
          from = new Date(this.targetDate);
          to = new Date(this.selectedDate);
        }

        if (from > to) {
          return "日付の範囲が無効です";
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    validatePastDate() {
      // 過去の日付は選択できない
      if (!this.isEmpty(this.selectedDate)) {
        const todayStart = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        if (new Date(this.selectedDate) <= todayStart) {
          return "過去の日付は無効です";
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  },
  watch: {
    selectedDate: {
      handler() {
        this.isOpenMenu = false;
      }
    }
  }
});
</script>

<template>
  <v-menu
    v-model="isOpenMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-on="on"
        v-bind="attrs"
        v-model="selectedDate"
        placeholder="YYYY-MM-DD"
        clearable
        readonly
        outlined
        dense
        :hide-details="hideDetails"
        color="var(--app-color)"
        :rules="[
          validateDateRange,
          validatePastDate
        ]"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectedDate"
      locale="ja"
      :max=max
      :min=min
      no-title
      color="var(--app-color)"
    />
  </v-menu>
</template>
